<template>
    <div class="darmin card">
        <div
            class="card-header pb-0 d-flex align-items-center justify-content-between"
            data-bs-toggle="collapse"
            :data-bs-target="`#card-${ramId}`"
            :aria-expanded="!disabled"
            :aria-controls="`card-${ramId}`"
        >
            <h5>Documentos Generados</h5>
            <i class="fas fa-angle-up"></i>
        </div>
        <div class="card-body theme-form">
            <div class="collapse show" :id="`card-${ramId}`">
                <div class="card-body files">
                    <div class="row g-0" v-if="!files?.length">No se han generado documentos.</div>
                    <div class="row g-0" v-else>
                        <div
                            class="col-lg-6 col-xl-4 mb-1 p-1"
                            v-for="file in files"
                            :key="file.file.id"
                        >
                            <ConsultaRenderedFile
                                :file="file.file"
                                @onRemoveRender="(id) => $emit('onRemoveRender', id)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { defineComponent, ref } from 'vue';
import ConsultaRenderedFile from './ConsultaRenderedFile.vue';

export default defineComponent({
    name: 'ConsultaRenderedFiles',
    components: { ConsultaRenderedFile },
    props: {
        files: Array,
        disabled: Boolean,
    },
    setup() {
        const ramId = ref(Math.floor(Math.random() * 1000));

        return {
            ramId,
        };
    },
});
</script>
